import { NgModule } from '@angular/core';
import { QuestionModule } from '../abstract/question.module';
import { QuestionTextComponent } from './question-text.component';
import { OptionTextModule } from '../../options';
@NgModule({
  imports: [
    QuestionModule,
    OptionTextModule,
  ],
  declarations:[QuestionTextComponent],
  exports:[QuestionTextComponent],
})
export class QuestionTextModule { }

